export default __webpack_public_path__ + "static/media/doctor2.b47a6e6d.jpg";